import React from 'react';

import $ from 'jquery'; 
import NrgComponent from './../../NrgComponent.jsx';
import { Content } from './Content.js';
import { Link } from 'react-router-dom';

export default class Navigation extends NrgComponent {

  constructor(props) {
    super(props);

    this.navBreakpoint = 760;
  }

  render() {
    // var hidden = { opacity: 0 };
    var hidden = { };

    return (
      <div ref="navContainer" className="Navigation" style={ hidden }>
        <ul>
          {Content.menu_items.map(function(page, i) {
            return (
                <li ref={`menuItem${page.name}`} key={i} className="inactive">
                  <Link to={page.href}>{page.name}</Link>
                  <div className="under">
                    <div className="line"></div>
                  </div>
                </li>
              );
          })}
        </ul>
      </div>
    );
  }

  // Mobile screens - set up mobile nav after render
  componentDidMount() {

    // Homepage has 2 names in different contexts, account for it
    var page = (this.props.page === 'homepage') ? 'thinking' : this.props.page;

    const $ele = $(this.refs.navContainer);
    const pageName = page.charAt(0).toUpperCase() + page.slice(1);
    const refName = `menuItem${pageName}`;
    const $target = $(this.refs[refName]);

    $target
      .removeClass('inactive');

    const nodeOffset = $target.offset().left;
    const halfItemWidth = $target.outerWidth(true) / 2;
    const halfWindowWidth = $(window).width() / 2;

    if ($(window).width() >= this.navBreakpoint) {
      $ele.css('opacity', 1);

      return;
    }

    const newScrollPos = (nodeOffset - halfWindowWidth) + halfItemWidth;

    $ele
      .css('opacity', 1)
      .scrollLeft(newScrollPos);
  }

  getPageName(page) {
    switch (page) {
      case 'homepage':
        return 'thinking'
      default:
        return page
    }
  }

};
